<div class="container-fluid">
    <div class="card mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col">
                    <div class="card-header">
                        <ul class="nav nav-tabs card-header-tabs" id="v-pills-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link" id="v-pills-countries-tab" data-toggle="pill" href="#v-pills-countries" role="tab" aria-controls="v-pills-countries" aria-selected="false">Countries</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="v-pills-regions-tab" data-toggle="pill" href="#v-pills-regions" role="tab" aria-controls="v-pills-regions" aria-selected="false">Regions</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="v-pills-provinces-tab" data-toggle="pill" href="#v-pills-provinces" role="tab" aria-controls="v-pills-provinces" aria-selected="false">Provinces</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link active" id="v-pills-villages-tab" data-toggle="pill" href="#v-pills-villages" role="tab" aria-controls="v-pills-villages" aria-selected="">Villages</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="tab-content" id="v-pills-tabContent">
            <div class="tab-pane fade" id="v-pills-countries" role="tabpanel" aria-labelledby="v-pills-countries-tab">
                <h5 class="card-title">Countries</h5>
                <table class="table table-sm text-left">
                    <app-countries [countriesList]="countriesList"></app-countries>
                </table>
            </div>
            <div class="tab-pane fade" id="v-pills-regions" role="tabpanel" aria-labelledby="v-pills-regions-tab">
                <h5 class="card-title">Regions</h5>
                <table class="table table-sm text-left">
                    <app-regions [regionsList]="regionsList" [countriesList]="countriesList" [countriesOptions]="countriesOptions"></app-regions>
                </table>
            </div>
            <div class="tab-pane fade" id="v-pills-provinces" role="tabpanel" aria-labelledby="v-pills-provinces-tab">
                <h5 class="card-title">Provinces</h5>
                <app-provinces [provincesList]="provincesList" [regionsList]="regionsList" [regionsOptions]="regionsOptions"></app-provinces>
            </div>
            <div class="tab-pane fade show active" id="v-pills-villages" role="tabpanel" aria-labelledby="v-pills-villages-tab">
                <h5 class="card-title">Villages</h5>
                <app-villages [villagesList]="villagesList" [provincesOptions]="provincesOptions" [provincesList]="provincesList"></app-villages>
            </div>
        </div>
    </div>
</div>
